import { StatusCode } from "@/modules/types/statusCode";

export class AppError extends Error {
  code: number = 0;
  message: string = "";
  reason: string = "";
  details: ErrorDetail[] = [];

  constructor(error: any) {
    const message = "Unknown error";
    super(message);
    this.name = "AppError";
    if (error instanceof AppError) {
      this.code = error.code;
      this.message = error.message;
      this.reason = error.reason;
    } else if (typeof error === "object" && error?.response?.data) {
      const err: AppError = error.response.data;
      this.message = err.message;
      this.code = err.code;
      this.reason = err.reason;
      this.details = err.details;
      // if (err.code == StatusCode.UNAUTHENTICATED) {
      //   if (typeof window !== "undefined") {
      //     window.location.href = routes.login;
      //   }
      // }
    } else if (typeof error === "object") {
      const appError = error as AppError;
      if (appError) {
        this.code = appError.code;
        this.message = appError.message;
        this.reason = appError.reason;
        this.details = appError.details;
      } else {
        const err = error as Error;
        this.message = err.message;
      }
    } else if (error instanceof TypeError) {
      this.message = error.message;
    }
  }

  logError(caller?: string) {
    if (process.env.NODE_ENV && process.env.NODE_ENV !== "production") {
      const obj = {
        caller,
        name: this.name,
        code: this.code,
        message: this.message,
        reason: this.reason,
        details: this.details,
      };
      console.error(obj);
    } else {
      // send log to server
    }
    //TODO: Implement logging
  }

  isAuthError() {
    return this.code == StatusCode.UNAUTHENTICATED;
  }
}

export type ErrorDetail = {
  "@type": string;
  metadata: Map<string, string>;
  reason: string;
};
